/*! Yubico Japan — image framing is now BAKED into the product pixels
    (every cut-out scaled so its alpha bbox fills ~0.94 of a centered square,
    done 2026-08-26). Runtime CSS-transform fitting is therefore DISABLED —
    applying it on top of baked images double-scales small products (e.g. the
    Nanos rendered ~3x too large and cropped). This file is kept as an
    intentional no-op so cached <script> references stay valid and the
    --fit-* CSS variables fall back to their identity defaults.
    Re-enabling runtime fitting would require reverting the baked assets. */
(function () {
  function apply() { /* no-op: framing is baked into the images */ }
  window.YUBIFIT = { apply: apply, table: {} };
})();
